<template>
    <div v-if="isVisible" class="widget hosting-widget">
        <button class="close" aria-label="Close" @click="handleClose">
            <i class="fal fa-times" />
        </button>
        <div class="content">
            <h3 class="title">
                Get FREE podcast hosting!
            </h3>
            <p class="description">
                Upgrade your podcast to the Starter plan and you’ll unlock free podcast hosting alongside pro-level player customizations.
            </p>
            <div class="buttons">
                <button class="btn btn-green" @click="handleUpgradeClick">
                    Upgrade to Starter
                </button>
                <button class="hide-button" @click="handleDontShowAgain">
                    Don’t show this message again.
                </button>
            </div>
        </div>
        <div class="image">
            <svg-vue icon="hosting-cta" />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        isHidden: false,
    }),

    computed: {
        ...mapState({
            /**
             * Determines if the widget is visible based on user meta and local
             * `isHidden` flat.
             *
             * @param {object} state Vuex state.
             * @returns {boolean} If the widget is visible.
             */
            isVisible(state) {
                return ! state.user.meta_data.hide_hosting_cta &&
                    ! this.isHidden;
            },

            firstFreeShow: ({ shows }) => {
                return shows && Object.values(shows)?.filter(({ plan }) => plan.isFree)?.[0];
            },
        }),
    },

    methods: {
        /**
         * Closes the widget and sets user meta to not show the widget again.
         *
         * @returns {void}
         */
        handleDontShowAgain() {
            this.handleClose();

            this.$store.dispatch('setUserMeta', {
                hide_hosting_cta: true,
            });
        },

        /**
         * Closes the widget.
         *
         * @returns {void}
         */
        handleClose() {
            this.isHidden = true;
        },

        /**
         * Handles upgrade button click.
         */
        handleUpgradeClick() {
            this.$router.push(`/shows/${this.firstFreeShow?.hash}/settings/plan`);
        },
    },
};
</script>
